module.exports = {
        srcSet: __webpack_public_path__ + "static/media/letter-664.d9800eb5.webp"+" 664w",
        images: [{path: __webpack_public_path__ + "static/media/letter-664.d9800eb5.webp",width: 664,height: 664}],
        src: __webpack_public_path__ + "static/media/letter-664.d9800eb5.webp",
        toString: function(){return __webpack_public_path__ + "static/media/letter-664.d9800eb5.webp"},
        
        width: 664,
        height: 664
      }